import type {GraphAtom} from "./graph/GraphAtom"

export type FeatureConnection = {
    feature: Feature;
    connections: GraphAtom[]
}

export type Feature = {
    name: string,
    atoms: GraphAtom[];
    connections: GraphAtom[];

    parent? : Feature;
    children? : Feature[];
    siblings? : FeatureConnection[];

    id?: string,
    uniqueName?: string
}

export const Features = Object.freeze({
    // Functional groups
    alkene: "alkene",
    alkine: "alkyne",
    alcohol: "alcohol",
    ether: "ether",
    sulfide: "sulfide",
    thiol: "thiol",
    isopropyl: "isopropyl",
    nitro: "nitro",
    nitrile: "nitrile",

    amine: "amine",
    amine1: "amine.1",
    amine2: "amine.2",
    amine3: "amine.3",

    // specific alkylHalides
    alklyHalid: "alkylHalide",
    alkylFlouride: "alkylHalide.flouride",
    alkylChloride: "alkylHalide.chloride",
    alkylBromide: "alkylHalide.bromide",
    alkylIodide: "alkylHalide.iodide",
    alkylAstatide: "alkylHalide.astatide",
    alkylTenneside: "alkylHalide.tenneside",

    // Carbonyl-like (but not necessarily carbonyls
    carbonyl: "carbonyl",
    aldehyde: "carbonyl.aldehyde",
    ketone: "carbonyl.ketone",
    carbAcid: "carbonyl.carboxylicAcid",
    ester: "carbonyl.ester",
    anhydride: "carbonyl.acidAnhydride",

    // Amides come in 3 flabors (primary, secondary and tertiary)
    amide: "carbonyl.amide",
    amide1: "carbonyl.amide.1",
    amide2: "carbonyl.amide.2",
    amide3: "carbonyl.amide.3",

    astatide: "carbonyl.acidHalide.astatide",
    bromide: "carbonyl.acidHalide.bromide",
    chloride: "carbonyl.acidHalide.chloride",
    flouride: "carbonyl.acidHalide.flouride",
    iodide: "carbonyl.acidHalide.iodide",
    tennesside: "carbonyl.acidHalide.tennesside",
    halide: "carbonyl.acidHalide",

    // Structural
    ring: "ring",
    benzene: "ring.6.benzene",
    bridgedRing: "ring.bridge",
    epoxide: "ring.3.epoxide",

    // Navigation structural features
    ringSystem: "ringSystem",
    atomCluster: "atomCluster",

    // Special chains
    chain: "chain",
    methyl: "chain.1.methyl",
    ethyl: "chain.2.ethyl",

    // Loose atoms
    atom: "atom",
    charge: "chg",
    lonePair: "lp",
    bondedH: "bondedH",

    // Molecules
    molecule: "molecule",
    diatomic: "molecule.2.diatomic",

    // Mechanistic
    protonated: "protonated"

})